<ion-menu
  side="end"
  contentId="main"
  menuId="notification-center"
  type="overlay"
  [style.--min-width.px]="currentSidebarWidth"
  (ionWillOpen)="onMenuWillOpen()"
  (ionDidClose)="onMenuDidClose()"
>
  <ion-header>
    <ion-toolbar>
      <ion-button
        slot="start"
        fill="clear"
        (click)="isChatOpen ? openChat(false) : closeSidebar()"
      >
<!--        <ion-icon-->
<!--          class="color-shape-border"-->
<!--          slot="icon-only"-->
<!--          name="close"-->
<!--          size="small"-->
<!--        ></ion-icon>-->
        <tr-icon
          slot="icon-only"
          [icon]="icon.cancel"
          [size]="iconSize.belowAverage"
          [color]="iconColor.lightPrimary"
        ></tr-icon>
      </ion-button>

      @if (isChatOpen && chatWithParty && isCompactHeader) {
        <div class="chat-title-row">
          <span class="chat-title-text">Chat with {{ chatWithParty.name }}</span>
          <tablesready-party-badge [party]="chatWithParty" [showTypeBadge]="true"></tablesready-party-badge>
        </div>
      }
    </ion-toolbar>
  </ion-header>

  <ion-content [scrollY]="false">
    <div class="centre-content">
      @if (isChatOpen) {
        <div class="chat-content border-border" [style.max-width.px]="baseSidebarWidth">
          @if (location) {
            <lib-frontend-chat-party
              [editPartyMethod]="editPartyMethod"
              [showPartyInfo]="!(isShortHeight && isKeyboardOpen)"
              [location]="location"
              [timezone]="location?.timezone"
              [party]="chatWithParty"
              [showReplyForm]="user?.account?.features?.savedReplies || false"
              [showTemplates]="user?.account?.features?.savedReplies || false"
              [hideTitle]="isCompactHeader"
              [cancel]="openChatArrow"
            ></lib-frontend-chat-party>
          }
        </div>
      }

      @if (!(isChatOpen && isMobile)) {
        <div class="main-content" #contentRef>
          <div #tabsRef>
            <h2 class="title-centre">Notification center</h2>

            <div class="centre-tabs">
              <tablesready-tabs
                paddingVertical=".5rem"
                [tabs]="tabs"
                [activeTab]="selectedTab"
                (changeTab)="onChangeNav($event)"
              >
                <ng-template appCustomTemplate [appCustomTemplateType]="'messages'">
                  <div class="notification-tab">
                    <p class="m-0" [class.color-shape-border]="selectedTab !== 'messages'">Messages</p>

                    @if (messagesCount$ | async; as count) {
                      <span class="notification-center-sidebar countbadge">
                <h4>{{ count > 99 ? '99+' : count }}</h4>
              </span>
                    }
                  </div>
                </ng-template>

                <ng-template appCustomTemplate [appCustomTemplateType]="'notifications'">
                  <div class="notification-tab">
                    <p class="m-0" [class.color-shape-border]="selectedTab !== 'notifications'">Notifications</p>
                    @if (notificationsCount$ | async; as count) {
                      <span class="notification-center-sidebar countbadge"><h4>{{ count > 99 ? '99+' : count }}</h4></span>
                    }
                  </div>
                </ng-template>
              </tablesready-tabs>
            </div>
          </div>

          <div
            class="messages-content"
            [style.max-height]="'calc(' + contentRef.offsetHeight + 'px - ' + tabsRef.offsetHeight +'px - 4rem)'"
            (scroll)="onContentScroll($event)"
          >
            @if (selectedTab === 'messages') {
              @if (messages.length === 0) {
                <ion-item lines="none" class="empty-state-item">
                  <ion-label class="ion-text-center ion-text-wrap">
                    <h2 class="mt-3 color-primary">No Messages</h2>
                    <p>Messages will appear here when guests text you</p>
                  </ion-label>
                </ion-item>
              }

              @if (messages.length > 0) {
                <ion-list>
                  @for (party of messages; track party._id) {
                    <ion-item
                      @markAsRead
                      [detail]="false"
                      lines="none"
                      button
                      (click)="openChat(true, party)"
                    >
                      <ion-label>
                        <div class="notification-center-sidebar message-block">
                          <div class="header">
                            <h2 data-dd-privacy="mask">{{ party.name || 'Guest' }}</h2>
                            <ion-button
                              title="Mark as read"
                              fill="clear"
                              size="small"
                              (click)="markAsReadMessage(party); $event.stopPropagation()">
                              <tr-icon
                                [icon]="icon.check"
                                [size]="iconSize.regular"
                                [color]="iconColor.green">
                              </tr-icon>
                            </ion-button>
                          </div>

                          <div class="unread-messages">
                            @for (inbound of getUnreadMessages(party); track inbound._id) {
                              <p class="message-item-row"><span data-dd-privacy="mask">{{ inbound.Body }}</span><small class="message-time text-muted"> {{ inbound.time | momentDateCalendar : location?.timezone }}</small></p>
                            }
                          </div>
                        </div>
                      </ion-label>
                    </ion-item>
                    <div class="item-separator border-border"></div>
                  }
                </ion-list>
              }

              @if (isLoadingMoreMessages) {
                <div class="load-more-indicator">
                  <ion-spinner name="bubbles"></ion-spinner>
                  <span>Loading more messages...</span>
                </div>
              }
            }

            @if (selectedTab === 'notifications') {
              @if (notifications.length === 0) {
                <ion-item lines="none" class="empty-state-item">
                  <ion-label class="ion-text-center ion-text-wrap">
                    <h2 class="mt-3 color-primary">No Notifications</h2>
                    <p>Notifications will appear here when guests join your waitlist</p>
                  </ion-label>
                </ion-item>
              }

              @if (notifications.length > 0) {
                <ion-list>
                  @for (party of notifications; track party._id) {
                    <ion-item
                      [detail]="false"
                      @markAsRead
                      lines="none"
                      button
                      (click)="openParty(party)"
                    >
                      <ion-label>
                        <div class="notification-center-sidebar message-block">
                          <div class="header">
                            <h2 data-dd-privacy="mask">{{ party.name || 'Guest' }}</h2>
                            <ion-button
                              title="Mark as read"
                              fill="clear"
                              size="small"
                              (click)="markAsReadNotification(party); $event.stopPropagation()">
                              <tr-icon
                                [icon]="icon.check"
                                [size]="iconSize.regular"
                                [color]="iconColor.green">
                              </tr-icon>
                            </ion-button>
                          </div>

                          <p class="notification-text" data-dd-privacy="mask">
                            {{ getNotificationText(party) }}
                          </p>

                          <div class="notification-meta">
                            <small class="text-muted">
                              <strong>Source:</strong> {{ getSourceLabel(party) }} •
                              <strong>Size:</strong> {{ party.size }} guest{{ party.size !== 1 ? 's' : '' }} •
                              {{ party.created_time | momentDateCalendar : location?.timezone  }}
                            </small>
                          </div>

                        </div>
                      </ion-label>
                    </ion-item>
                    <div class="item-separator border-border"></div>
                  }
                </ion-list>
              }

              @if (isLoadingMoreNotifications) {
                <div class="load-more-indicator">
                  <ion-spinner name="bubbles"></ion-spinner>
                  <span>Loading more notifications...</span>
                </div>
              }
            }
          </div>

          @if (
            (selectedTab === 'notifications' && notifications.length > 0) ||
            (selectedTab === 'messages' && messages.length > 0)
          ) {
            <div
              class="mark-all-as-read background-background border-border"
              (pointerdown)="startHold(selectedTab === 'notifications' ? 'notifications' : 'messages')"
              (pointerup)="cancelHold()"
              (pointerleave)="cancelHold()"
              (pointercancel)="cancelHold()"
            >
              <div class="hold-button">
                <div class="hold-fill" [style.width.%]="fillProgress" [style.transition]="fillTransitionMs ? 'width ' + fillTransitionMs + 'ms linear' : 'none'"></div>
                <span class="mark-all-label">Mark all as read</span>
              </div>
            </div>
          }
        </div>
      }
    </div>

  </ion-content>
</ion-menu>
